import { motion } from "framer-motion";

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14, as: Tag = "h1", ariaLabel }) => (
  <Tag className={className} aria-label={ariaLabel}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);
